/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'instagram': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.101.9 2 2 2h14c1.1 0 2-.899 2-2V5c0-1.1-.9-2-2-2zm-7.016 14.523a5.54 5.54 0 005.538-5.539c0-.338-.043-.664-.103-.984H19v7.216a.689.689 0 01-.693.69H5.693a.69.69 0 01-.693-.69V11h1.549c-.061.32-.104.646-.104.984a5.54 5.54 0 005.539 5.539zm-3.461-5.539a3.461 3.461 0 116.922 0 3.461 3.461 0 01-6.922 0zM18.307 8h-1.615A.694.694 0 0116 7.308V5.691c0-.382.31-.691.691-.691h1.615c.384 0 .694.309.694.691v1.616c0 .381-.31.693-.693.693z" _fill="#81899D"/>'
  }
})
